import { render, staticRenderFns } from "./unitItem.vue?vue&type=template&id=673a732b&scoped=true"
import script from "./unitItem.vue?vue&type=script&lang=js"
export * from "./unitItem.vue?vue&type=script&lang=js"
import style0 from "./unitItem.vue?vue&type=style&index=0&id=673a732b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673a732b",
  null
  
)

export default component.exports